import { useSelector } from 'react-redux';

export const useProfiles = () => {
    const { loadingProfiles, profiles } = useSelector(state => state.driverPerformanceRiskEventsTabRedux || {});
    return { loadingProfiles, profiles };
};
